export default __webpack_public_path__ + "static/media/Rachel.98df8c5e.png";